export default class SubmissionForm {
    constructor(root, node_prefix, ajax_action, data_args) {
        this.root = root;
        this.node_prefix = node_prefix;
        this.ajax_action = ajax_action;
        this.data_args = data_args;

        this.fields = this.getAllNodes('field');
        this.submit = this.getNode('submit');
        this.error_message = this.getNode('error-message');
        this.custom_error_message = this.getNode('custom-error-message');
        this.sending_message = this.getNode('sending-message');
        this.sent_message = this.getNode('sent-message');
        this.sent_error_message = this.getNode('sent-error-message');

        this.fields.forEach((field) => {
            field.addEventListener('blur', (e) => {
                this.validateField(e.target);
            });
            field.addEventListener('change', (e) => {
                this.validateField(e.target);
            });
        });

        if(this.getField('preferred-contact')) {
            this.getField('preferred-contact').addEventListener('blur', (e) => {
                this.optional(this.getField('email'));
                this.optional(this.getField('phone'));

                if(e.target.value == 'email') {
                    this.required(this.getField('email'));
                } else if(e.target.value == 'phone') {
                    this.required(this.getField('phone'));
                }
            });
        }

        this.submit.addEventListener('click', (e) => {
            e.preventDefault();

            this.validateForm();

            if(!this.hasErrors()) {
                //send message
                this.hide(this.error_message);
                this.fields.forEach((field) => {
                    this.disable(field);
                });
                this.disable(this.submit);
                this.show(this.sending_message);
                this.sendMessage();
            } else {
                this.show(this.error_message);
            }
        });
    }

    sendMessage() {
        // make fields dynamic
        var field_data = {}

        this.fields.forEach((field) => {
            field_data[field.name.replaceAll('-', '_')] = field.value;
        });

        if(this.ajax_action instanceof Function) {
            this.ajax_action();
        } else if(this.ajax_action) {
            jQuery.ajax({
                url: window.theme.variables.ajax_url + '?action=' + this.ajax_action,
                data: {
                    ...this.data_args,
                    page: window.location.href,
                    fields: field_data
                },
                success: (response) => {
                    this.hide(this.sending_message);
    
                    if(response.status == 'error') {
                        this.show(this.sent_error_message);
    
                        console.warn('AJAX Error: ' + response.message);
    
                        setTimeout(() => {
                            this.fields.forEach((field) => {
                                this.enable(field);
                            });
    
                            this.enable(this.submit);
                            this.hide(this.sent_error_message);
                        }, 4000);
                    } else if(response.status == 'success') {
                        this.show(this.sent_message);
    
                        setTimeout(() => {
                            this.resetForm();
                        }, 4000);
                    }
                }
            });
        }
    }

    validateField(field) {
        if(field.classList.contains(this.getClassName('required')) && field.value == "") {
            field.classList.add('--error');
        } else {
            field.classList.remove('--error');
        }
    }

    resetForm() {
        this.hide(this.sent_message);
        this.hide(this.sent_error_message);
        this.hide(this.error_message);
        this.hide(this.custom_error_message);
        this.hide(this.sending_message);

        this.fields.forEach((field) => {
            field.value = "";

            if(field.dataset.defaultValue) {
                field.value = field.dataset.defaultValue;
            }

            if(field.name == 'email' || field.name == 'phone') {
                this.optional(field);
            }

            field.classList.remove('--error');

            this.enable(field);
        });

        this.enable(this.submit);
    }

    hasErrors() {
        if(this.root.querySelectorAll('.--error').length == 0) {
            return false;
        }

        return true;
    }

    required(node) {
        if(node) {
            node.classList.add(this.getClassName('required'));
        }
    }

    optional(node) {
        if(node) {
            node.classList.remove(this.getClassName('required'));
        }
    }

    enable(node) {
        if(node) {
            node.classList.remove('--disabled');
        }
    }

    disable(node) {
        if(node) {
            node.classList.add('--disabled');
        }
    }

    show(node) {
        if(node) {
            node.classList.add('--active');
        }
    }

    hide(node) {
        if(node) {
            node.classList.remove('--active');
        }
    }

    validateForm() {
        this.fields.forEach((field) => {
            if(field.classList.contains(this.getClassName('required')) && field.value == "") {
                field.classList.add('--error');
            } else {
                field.classList.remove('--error');
            }
        });
    }

    getClassName(class_name) {
        return 'js-' + this.node_prefix + '-' + class_name;
    }

    getNode(node_name) {
        return this.root.querySelector('.js-' + this.node_prefix + '-' + node_name);
    }

    getAllNodes(node_name) {
        return this.root.querySelectorAll('.js-' + this.node_prefix + '-' + node_name);
    }

    getField(field_name) {
        var return_value = null;

        this.fields.forEach((field) => {
            if(field.getAttribute('name') == field_name) {
                return_value = field;
            }
        });

        return return_value;
    }
}
